import CONTENT, { EL } from '../../DOM/content/CONTENT.js';
import CITE from '../../DOM/cite/CITE.js';
import CODE, { code } from '../../DOM/code/CODE.js';
import PRE, { text } from '../../DOM/pre/PRE.js';
import STRING from '../../../STRING.js';
import { HTMLELEMENT } from '../../../enums/HTMLELEMENT.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
// Model Structure
export const codeblockAttr = makeAttrStruct([]);
export const codeblockData = makeDataStruct([
    ['code'],
    ['cite']
]);
export const codeblockModel = makeStruct([
    ['attributes', codeblockAttr],
    ['data', codeblockData]
]);
// Simplified Model
export function codeblock(language, codeText, cite = '') {
    return codeblockModel(codeblockAttr(), codeblockData(code(language, codeText), text(cite)));
}
/** Displays a pre-formatted block of code */
export default class CODEBLOCK extends CONTENT {
    pre;
    code;
    cite;
    constructor(node, model) {
        super(node, HTMLELEMENT.DIV, model);
        this.addClass('codeblock');
        this.pre = new PRE(this, text());
        this.code = new CODE(this.pre, model.data.code);
        this.cite = new CITE(this, model.data.cite);
        // Prism.highlightElement(this.code.el);
    }
}
export { CITE, CODE, EL, PRE, STRING };
